// services/apiSlice.js or wherever your API slice is defined
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../../utils/baseQueryWithReauth';

export const roleApi = createApi({
  reducerPath: 'roleApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    createRole: builder.mutation({
      query: ({RoleName}) => ({
        url: `/WebRole/CreateRole`,
        method: "Post",
        params: { RoleName },
      }),
    }),
    getAllRoles: builder.query({
      query: ({PageNumber = 1, Take = 10, search}) => ({
        url: `/WebRole/GetAllRoles`,
        method: "Get",
        params: {PageNumber, Take, search}
      }),
    }),
    updateRole: builder.mutation({
      query: ({NewName, Id}) => ({
        url: `/WebRole/UpdateRole`,
        method: "Post",
        params: { NewName, Id },
      }),
    }),
    deleteRole: builder.mutation({
      query: ({Id}) => ({
        url: `/WebRole/DeleteRole`,
        method: "Post",
        params: { Id },
      }),
    }),
    getAllPermissions: builder.query({
      query: ({id}) => ({
        url: `/WebRole/GetAllPermissions`,
        method: "Get",
        params: {id}
      }),
    }),
    updatePermissions: builder.mutation({
      query: ({id, backendFormattedPermissions}) => ({
        url: `/WebRole/EditPermissions`,
        method: "Post",
        params: { id },
        body: backendFormattedPermissions
      }),
    }),
  }),
});

export const { 
  useCreateRoleMutation,
  useLazyGetAllRolesQuery,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
  useGetAllPermissionsQuery,
  useUpdatePermissionsMutation
} = roleApi;